import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Icon from "../Icon";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import Hours from "../Hours";
import { business, fullAddress } from "../../seo/business";
import { locations } from "../../seo/routes";

const Footer = () => (
  <footer className="footer">
    <div className="footer-columns">
      <section aria-labelledby="footer-contact">
        <h2 id="footer-contact">{business.name}</h2>
        <address>
          <a href={business.mapsUrl} target="_blank" rel="noopener noreferrer">
            {fullAddress}
          </a>
          <br />
          <a href={`tel:${business.phone}`}>{business.phone}</a>
        </address>
        <p>We speak {business.languages.join(", ").replace(/, ([^,]*)$/, " & $1")}.</p>
        <a
          href={business.instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-social"
          aria-label="Benson Dental Studio on Instagram (opens in new tab)"
        >
          <Icon icon={faInstagram} /> Instagram
        </a>
      </section>
      <section aria-labelledby="footer-hours">
        <h2 id="footer-hours">Hours</h2>
        <Hours compact />
      </section>
    </div>
    <nav className="footer-areas" aria-label="Areas we serve">
      Serving{" "}
      {locations.map((location, index) => (
        <React.Fragment key={location.slug}>
          {index > 0 && " · "}
          <Link to={`/${location.slug}`}>{location.name}</Link>
        </React.Fragment>
      ))}
    </nav>
    <p className="footer-copyright">
      © {new Date().getFullYear()} {business.name} · Dentist in Bensonhurst, Brooklyn, NY
    </p>
  </footer>
);

export default Footer;
